module.exports = "/_next/static/images/ae5defd3730012cef415c27073a64db9-nu-card-md@1x.jpg.webp";